"use client";

import { store } from "@/src/redux/store";
import { client } from "@/src/utils/apollo";
import { ApolloProvider } from "@apollo/client";
import TaptoTop from "@components/ui/TapTop";
import { Provider } from "react-redux";
import { Bounce, ToastContainer } from "react-toastify";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        {children}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <TaptoTop />
        {/*
                  hide customizer
                  <Customizer /> */}
      </Provider>
    </ApolloProvider>
  );
}
